"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'shop_header',
  cname: '店铺头部',
  // 标题名称
  icon: 't-icon-zujian-zuhezujian',
  configName: 'c_shop_header',
  // 右侧配置名称
  type: 0,
  // 0 基础组件 1 营销组件 2 工具组件
  defaultName: 'shopHeader',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mobileTheme'])), {}, {
    // 特色标签，最多展示4个
    tagList: function tagList() {
      if (!this.configObj) return [];
      return this.configObj.tagsConfig.list.slice(0, 4);
    },
    // 搜索框提示文字
    hotWord: function hotWord() {
      var data = this.configObj;
      if (!data) return '';
      return data.placeWords.val || '搜索商品';
    },
    // 头部背景渐变
    bgStyle: function bgStyle() {
      var color = this.configObj.bgColor.color;
      return {
        background: "linear-gradient(180deg, ".concat(color[0].item, ", ").concat(color[1].item, ")")
      };
    },
    // logo/地址文字颜色
    textStyle: function textStyle() {
      return {
        color: this.configObj.textColor.color[0].item
      };
    },
    // 搜索框样式
    searchStyle: function searchStyle() {
      return {
        background: this.configObj.searchBgColor.color[0].item,
        color: this.configObj.searchTextColor.color[0].item,
        'border-radius': this.configObj.contentStyle.val + 'px'
      };
    },
    // 搜索按钮文字颜色
    btnStyle: function btnStyle() {
      return {
        color: this.configObj.btnColor.color[0].item
      };
    },
    // 标签文字颜色
    tagStyle: function tagStyle() {
      return {
        color: this.configObj.tagColor.color[0].item
      };
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler() {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    }
  },
  data: function data() {
    return {
      // 默认初始化数据禁止修改
      defaultConfig: {
        isHide: false,
        name: 'shopHeader',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '店铺头部'
        },
        // logo
        logoConfig: {
          isShow: 1,
          tabTitle: '设置logo',
          title: '店铺logo',
          tips: '建议上传大小：宽138px，高48px',
          header: '设置logo',
          url: 'https://api.admin.cunxian.zlssdt.com/crmebimage/public/product/2026/06/16/ccff412f391248ddbb6491639607fab6y1u4df20mv.png'
        },
        // 收货地址文字
        addressConfig: {
          isShow: 1,
          title: '地址文字',
          val: '选择收货地址',
          place: '请输入地址提示文字',
          max: 15
        },
        // 搜索提示文字
        placeWords: {
          isShow: 1,
          title: '提示文字',
          tabTitle: '提示文字设置',
          val: '搜索商品',
          place: '请输入搜索提示文字',
          max: 15
        },
        // 搜索按钮文字
        searchBtnConfig: {
          isShow: 1,
          title: '按钮文字',
          val: '搜索',
          place: '请输入按钮文字',
          max: 4
        },
        // 特色标签（图片+文字，最多4个）
        tagsConfig: {
          tabTitle: '特色标签',
          info: '最多可设置4个标签，建议上传小图标，鼠标拖拽可调整顺序',
          maxList: 4,
          list: [{
            img: 'https://api.admin.cunxian.zlssdt.com/crmebimage/public/product/2026/06/16/ce268e35c71444768e37cb2b6e3a343bg36q5ugcr6.png',
            val: '安徽本土严选'
          }, {
            img: 'https://api.admin.cunxian.zlssdt.com/crmebimage/public/product/2026/06/16/cea895a4d7774e279a3eed78ee57ec56pwmn76yl3a.png',
            val: '全程冷链'
          }, {
            img: 'https://api.admin.cunxian.zlssdt.com/crmebimage/public/product/2026/06/16/7d92e654249d41589d4b22968e5c3f96x5luhtfbnz.png',
            val: '基地直采'
          }, {
            img: 'https://api.admin.cunxian.zlssdt.com/crmebimage/public/product/2026/06/16/2efa2aef400a4559aa3a1db62c4dc1ccpfrjiri8xx.png',
            val: '今日订明日达'
          }]
        },
        // 背景渐变色
        bgColor: {
          tabTitle: '颜色设置',
          title: '背景渐变',
          color: [{
            item: '#42CA4C '
          }, {
            item: '#FFF '
          }],
          default: [{
            item: '#42CA4C'
          }, {
            item: '#FFF'
          }]
        },
        // 地址文字颜色
        textColor: {
          title: '地址文字颜色',
          color: [{
            item: '#111111'
          }],
          default: [{
            item: '#111111'
          }]
        },
        // 搜索框背景色
        searchBgColor: {
          title: '搜索框颜色',
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        // 搜索框文字色
        searchTextColor: {
          title: '搜索框文字色',
          color: [{
            item: '#999999'
          }],
          default: [{
            item: '#999999'
          }]
        },
        // 搜索按钮文字色
        btnColor: {
          title: '按钮文字色',
          color: [{
            item: '#333333'
          }],
          default: [{
            item: '#333333'
          }]
        },
        // 标签文字色
        tagColor: {
          title: '标签文字色',
          color: [{
            item: '#666666'
          }],
          default: [{
            item: '#666666'
          }]
        },
        // 搜索框圆角
        contentStyle: {
          title: '搜索框圆角',
          name: 'contentStyle',
          val: 20,
          min: 0,
          max: 20
        }
      },
      configObj: null,
      pageData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.num) {
        _this.pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
        _this.setConfig(_this.pageData);
      }
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      this.configObj = data;
    }
  }
};